<template>
  <div>
    <div class="container">
      <!-- 头部 -->
      <van-nav-bar fixed title="积分明细" left-arrow @click-left="onClickLeft" id="vnb"></van-nav-bar>

      <!-- 主体 -->
      <div class="main">
        <!-- 积分区 -->
        <div class="main-points">
          <!-- 总积分 -->
          <div class="points-all fy">{{mingxi.allScore}}</div>
          <!-- 今日赚取积分 +5 -->
          <div class="today fy">
            <div class="box">
              <span class="left">今日赚取积分：</span>
              <span class="center">+</span>
              <span class="right">{{mingxi.todayScore}}</span>
            </div>
          </div>
          <!-- 过期时间 300 time 去掉-->
          <!-- <div class="time">
            <span>您将有3000积分将于2020.7.17 00:00:00过期</span>
          </div>-->
        </div>

        <!-- 积分交易记录：文字 -->
        <div class="main-record fy">
          <span>积分交易记录</span>
        </div>

        <!-- 积分交易记录 -->
        <div class="main-recordAll fy">
          <!-- van-tabs 开始 -->
          <van-tabs
            class="recordAll-tabs"
            @change="onChangeTab"
            color="#FC6524"
            title-active-color="#FC6524"
            sticky
            offset-top="45"
          >
            <!-- 支出/赚取 状态 -->
            <van-tab v-for="(val, ind) in tabbars" :title="val.name" :key="ind">
              <!-- 日期说明 -->
              <div class="recordAll-title">
                <span class="left fy">说明/日期</span>
                <span class="left fy">积分变动/余额</span>
              </div>
              <!-- 记录 -->
              <div class="record">
                <!-- van-list 开始 -->
                <van-list
                  class="record-list"
                  v-model="loading"
                  :immediate-check="false"
                  :finished="finished"
                  @load="getMoreProduct"
                  :finished-text="finishedText"
                >
                  <!-- 循环 -->
                  <div class="record-list-item" v-for="(item,eq) in val.product_list" :key="eq">
                    <div class="record-list-item-a">
                      <div class="record-list-item-b">
                        <div class="record-list-item-content">
                          <!-- s -->
                          <div class="left">
                            <span class="left-t" v-if="item.status==1">投资-聚财宝</span>
                            <span class="left-t" v-if="item.status==2">商品兑换</span>
                            <span class="left-d">{{item.createTime}}</span>
                          </div>
                          <!-- d -->
                          <div class="right">
                            <!-- <span class="jia">+</span>
                            <span class="jian">-</span>-->

                            <span class="right-t" v-show="item.status==1">+{{item.scoreChange}}</span>
                            <span class="right-t" v-show="item.status==2">-{{item.scoreChange}}</span>
                            <span class="right-d">{{item.score}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </van-list>
                <!-- van-list 结束 -->
              </div>
            </van-tab>
          </van-tabs>
          <!-- van-tabs 结束 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs, Toast, Dialog, Tag, List } from 'vant';
import * as ProductApi from '@/api/product';
import * as GoodsApi from '@/api/goods';

export default {
  name: 'pointsmingxi',
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [List.name]: List
  },
  data () {
    return {
      add: false,
      del: false,
      mingxiList: [],
      loading: false,
      finished: false,
      finishedText: "",
      currentIndex: 0,
      tabbars: [
        { name: '全部记录', status: '', pageNo: 0, product_list: [] },
        { name: '收入记录', status: '1', pageNo: 0, product_list: [] },
        { name: '支出记录', status: '2', pageNo: 0, product_list: [] }
      ],
      // 积分明细
      mingxi: []
    };
  },
  // --------
  created () {
    this.onChangeTab(0)
  },
  //  --------
  methods: {
    // 回退
    onClickLeft () {
      this.goableBack();
    },
    // 获取数据
    onChangeTab (index) {
      // ======================================
      this.loading = true;
      this.tabbars[index].pageNo = 1;
      let pageNo = this.tabbars[index].pageNo;
      // let pageNo = 1;
      let pageSize = 10;
      let status = this.tabbars[index].status;
      let the = this;
      // =========================================
      GoodsApi.scoreHistory({
        status,
        pageNo,
        pageSize
      })
        .then(data => {
          // =============
          if (data.history.list.length === 0) {
            this.finishedText = "没有记录了";
          } else {
            this.finishedText = "已经到底了";
          }
          if (data.history.list.length < pageSize) {
            this.finished = true;
          }
          else {
            this.finished = false;
          }

          console.log("change", index, this.tabbars[index].pageNo);

          the.tabbars[index].product_list = data.history.list;
          if (this.currentIndex != index) {
            this.currentIndex = index;
            this.tabbars[index].pageNo = 2;
            // this.tabbars[index].pageNo = 0;

            console.log(index, 1);
          }
          else {

          }
          this.tabbars[index].pageNo++;
          the.loading = false

          // the.tabbars[index].product_list = the.tabbars[index].product_list.concat(data.history.list);
          the.mingxi = data;
          // console.log(data.history.list)

        })
        .catch(e => {
          Toast(e.msg || e.message)
        })
      return false;
    },
    // 获得更多
    getMoreProduct () {
      this.loading = true;
      let index = this.currentIndex;
      let pageNo = this.tabbars[index].pageNo;
      let status = this.tabbars[index].status;
      let pageSize = 10;
      let the = this
      GoodsApi.scoreHistory({
        status,
        pageNo,
        pageSize
      })
        .then(data => {

          console.log("getMoreProduct", index, this.tabbars[index].pageNo);
          the.tabbars[index].product_list = the.tabbars[index].product_list.concat(data.history.list);

          if (data.history.list.length === 0) {
            this.finishedText = "没有记录了";
          } else {
            this.finishedText = "已经到底了";
          }
          if (data.history.list.length < pageSize) {
            this.finished = true;
          } else {
            this.finished = false;
            //原本page頁面增加

          }
          this.tabbars[index].pageNo++;

          the.loading = false



        })
        .catch(e => {
          Toast(e.msg || e.message)
        })
    }

  }
};
</script>

<style lang="less" scoped>
// navBar
/deep/ .van-nav-bar {
  background-color: #ffffff !important;
  background-image: none;
}

#vnb /deep/ .van-nav-bar__title {
  color: #000000 !important;
  font-size: 16px;
}
#vnb /deep/ .van-nav-bar__left .van-icon {
  color: #000000 !important;
  font-size: 16px;
}

// tab 标签页
/deep/ .van-tabs__line {
  height: 2px;
}
/deep/ .van-tab__text {
  font-size: 15px;
}
/deep/ .van-tabs__wrap {
  margin: 0 10px;
  letter-spacing: 1px;
}

/deep/ .van-tabs__content {
  // margin: 0;
}
// 整体
.container {
  margin-top: 59px;
  background-color: #f3f4f6;

  // 主体
  .main {
    margin: 14px 12px;

    //积分总览
    .main-points {
      height: 124px;
      border-radius: 6px;
      background-image: url(../../assets/img/pointsmingxi/mingxi.png);
      background-size: 375px;

      // 总积分
      .points-all {
        height: 50px;
        line-height: 60px;
        font-weight: 700;
        text-align: center;
        font-size: 27px;
        color: #ffffff;
      }
      // 今日赚取积分
      .today {
        margin-top: 5px;
        display: flex;
        justify-content: center;

        .box {
          // width: 128px;
          height: 22px;
          color: #c84608;
          font-size: 12px;
          padding: 0 6px;
          font-weight: 700;
          border-radius: 50px;
          background-color: #fea779;
          display: flex;
          justify-content: center;
          align-items: center;

          .right {
            font-size: 16px;
          }
        }
      }
      // 过期时间
      .time {
        opacity: 0.85;
        color: #ffeae0;
        font-size: 12px;
        margin-top: 15px;
        text-align: center;
        letter-spacing: 0.5px;
      }
    }
    // 文字
    .main-record {
      margin-top: 31px;
      font-size: 16px;
      font-weight: 700;
      color: #333333;
      letter-spacing: 0.5px;
    }
    // 积分记录
    .main-recordAll {
      // height: 259px;
      margin-top: 11px;
      background-color: #ffffff;
      border-radius: 6px;
      // overflow: auto;

      .recordAll-tabs {
        // border: 1px solid #000000;
        // box-sizing: border-box;

        // 日期说明
        .recordAll-title {
          display: flex;
          justify-content: space-between;
          // align-items: center;
          line-height: 20px;
          letter-spacing: 1px;
          border-bottom: 1px solid #f4f4f4;

          .left {
            font-size: 13px;
            color: #333333;
            font-weight: 700;
            // margin-top: 35px;
            margin: 35px 13px 10px 13px;
          }
        }

        // 记录
        .record {
          .record-list {
            .record-list-item {
              // border: 1px solid #000000;
              // box-sizing: border-box;
              .record-list-item-a {
                margin: 0 13px;

                // 列表内容
                .record-list-item-content {
                  height: 53px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  border-bottom: 1px solid #f4f4f4;

                  .left {
                    text-align: left;

                    .left-t {
                      font-size: 13px;
                      font-weight: 700;
                      color: #666666;
                      display: block;
                    }
                    .left-d {
                      font-size: 11px;
                      color: #666666;
                    }
                  }
                  .right {
                    text-align: right;

                    .right-t {
                      font-size: 15px;
                      font-weight: 700;
                      color: #fc6524;
                      display: block;
                    }
                    .right-d {
                      font-size: 11px;
                      color: #666666;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
